module.exports = __webpack_public_path__ + "img/DrSharonLee.e6aa0f29.png";